import { useCallback } from 'react';
import { useFocusEffect, useRouter } from 'expo-router';

import { useMenuRedirectQuery } from '../../GraphQL/MenuRedirect.generated';

// Here we handle the short menu link redirects (/west-3rd -> /west-3rd/menu).
export const useMenuRedirect = (skip: boolean, params: MenuRedirectParams) => {
  const { restaurantSlug } = params;

  const router = useRouter();

  const [restaurantQueryResponse] = useMenuRedirectQuery({
    variables: { id: restaurantSlug ?? '' },
    requestPolicy: 'cache-and-network',
    pause: !restaurantSlug || skip,
  });

  const isShortMenuLink = Boolean(restaurantQueryResponse?.data?.restaurant);

  useFocusEffect(
    useCallback(() => {
      if (!isShortMenuLink || !restaurantSlug) return;

      router.replace({
        pathname: '/[restaurantSlug]/menu',
        params: { restaurantSlug },
      });
    }, [isShortMenuLink, restaurantSlug, router]),
  );

  return restaurantQueryResponse.fetching;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type MenuRedirectParams = {
  restaurantSlug: string | undefined;
};
